export default __webpack_public_path__ + "static/media/ic_cloud-sync.ccec3b01.webp";